import { render, staticRenderFns } from "./ReferralTeacher.vue?vue&type=template&id=327b3e18&scoped=true&"
import script from "./ReferralTeacher.vue?vue&type=script&lang=js&"
export * from "./ReferralTeacher.vue?vue&type=script&lang=js&"
import style0 from "./ReferralTeacher.vue?vue&type=style&index=0&id=327b3e18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327b3e18",
  null
  
)

export default component.exports